module.exports = __webpack_public_path__ + "img/piments-rouge.ac01c77b.png";